import React from 'react';
import { Link } from 'react-router-dom';
import { Video, Mail, MapPin, Phone, Facebook, Twitter, Linkedin, Instagram } from 'lucide-react';

const Footer: React.FC = () => {
  const footerLinks = {
    product: [
      { label: 'Özellikler', href: '/features', internal: true },
      { label: 'Fiyatlandırma', href: '/pricing', internal: true },
      { label: 'Güvenlik', href: '/security', internal: true },
      { label: 'Entegrasyonlar (yakında)', href: '/contact', internal: true },
    ],
    company: [
      { label: 'Hakkımızda', href: '/about', internal: true },
      { label: 'Kariyer (yakında)', href: '/contact', internal: true },
      { label: 'Blog (yakında)', href: '/contact', internal: true },
      { label: 'İletişim', href: '/contact', internal: true },
    ],
    resources: [
      { label: 'Dokümantasyon (yakında)', href: '/contact', internal: true },
      { label: 'Yardım Merkezi', href: '/faq', internal: true },
      { label: 'API (yakında)', href: '/contact', internal: true },
      { label: 'Topluluk (yakında)', href: '/contact', internal: true },
    ],
    legal: [
      { label: 'Gizlilik Politikası (yakında)', href: '/contact', internal: true },
      { label: 'Kullanım Şartları (yakında)', href: '/contact', internal: true },
      { label: 'Çerez Politikası (yakında)', href: '/contact', internal: true },
      { label: 'KVKK (yakında)', href: '/contact', internal: true },
    ],
  };

  const socialLinks = [
    { icon: Facebook, href: 'https://www.facebook.com/', label: 'Facebook' },
    { icon: Twitter, href: 'https://twitter.com/', label: 'Twitter' },
    { icon: Linkedin, href: 'https://www.linkedin.com/', label: 'LinkedIn' },
    { icon: Instagram, href: 'https://www.instagram.com/', label: 'Instagram' },
  ];

  const renderLink = (link: { label: string; href: string; internal: boolean }) =>
    link.internal ? (
      <Link to={link.href} className="text-gray-400 hover:text-white transition">
        {link.label}
      </Link>
    ) : (
      <a href={link.href} className="text-gray-400 hover:text-white transition">
        {link.label}
      </a>
    );

  return (
    <footer className="bg-slate-900 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-8">
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <Video className="w-8 h-8 text-purple-400" />
              <span className="text-2xl font-bold text-white">TBKMeet</span>
            </div>
            <p className="text-gray-400 mb-6">
              Toplantılarınızı bir üst seviyeye taşıyın. Kristal netliğinde görüntü kalitesi ve kesintisiz bağlantı.
            </p>

            <div className="space-y-3">
              <a
                href="mailto:info@tbkmeet.com"
                className="flex items-center space-x-3 text-gray-400 hover:text-white transition"
              >
                <Mail className="w-5 h-5 text-purple-400" />
                <span>info@tbkmeet.com</span>
              </a>
              <a
                href="tel:+903129220635"
                className="flex items-center space-x-3 text-gray-400 hover:text-white transition"
              >
                <Phone className="w-5 h-5 text-purple-400" />
                <span>0 312 922 0635</span>
              </a>
              <div className="flex items-center space-x-3 text-gray-400">
                <MapPin className="w-5 h-5 text-purple-400" />
                <span>Ankara, Türkiye</span>
              </div>
            </div>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Ürün</h3>
            <ul className="space-y-2">
              {footerLinks.product.map((link) => (
                <li key={link.label}>{renderLink(link)}</li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Şirket</h3>
            <ul className="space-y-2">
              {footerLinks.company.map((link) => (
                <li key={link.label}>{renderLink(link)}</li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Kaynaklar</h3>
            <ul className="space-y-2">
              {footerLinks.resources.map((link) => (
                <li key={link.label}>{renderLink(link)}</li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Yasal</h3>
            <ul className="space-y-2">
              {footerLinks.legal.map((link) => (
                <li key={link.label}>{renderLink(link)}</li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10">
          <div className="max-w-md">
            <h3 className="text-white font-semibold mb-2">Bültene Abone Ol</h3>
            <p className="text-gray-400 mb-4">Yeniliklerden haberdar olmak için e-posta adresinizi girin.</p>
            <div className="flex gap-2">
              <input
                type="email"
                id="footer-newsletter"
                placeholder="E-posta adresiniz"
                className="flex-1 px-4 py-2 bg-white/5 border border-white/10 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-purple-500"
              />
              <button
                type="button"
                className="px-6 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-lg transition"
                onClick={() => {
                  const input = document.getElementById('footer-newsletter') as HTMLInputElement | null;
                  const val = input?.value?.trim() || '';
                  if (!val || !val.includes('@')) {
                    window.alert('Geçerli bir e-posta girin.');
                    return;
                  }
                  window.alert('Abonelik isteğiniz alındı. Teşekkürler!');
                  if (input) input.value = '';
                }}
              >
                Abone Ol
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col md:flex-row items-center justify-between">
          <p className="text-gray-400 text-sm mb-4 md:mb-0">
            © 2026 TBKMeet. Tüm hakları saklıdır.
          </p>

          <div className="flex items-center space-x-4">
            {socialLinks.map((social) => (
              <a
                key={social.label}
                href={social.href}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-white/5 hover:bg-purple-600 text-gray-400 hover:text-white transition"
                aria-label={social.label}
              >
                <social.icon className="w-5 h-5" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
